import RetailerAddressEdit from './RetailerAddressEdit'
import RetailerAddressList from './RetailerAddressList'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: RetailerAddressList,
    edit: RetailerAddressEdit
}
